import { create } from 'zustand';

type FormProps = {
  currentStep: number;
  entityType: string;
  isFormSubmittedSuccess: boolean;
  isFormSubmittedFailure: boolean;
  setIsFormSubmittedSuccess: (status: boolean) => void;
  setIsFormSubmittedFailure: (status: boolean) => void;
  changeEntityType: (newEntityType: string) => void;
  nextStep: () => void;
  prevStep: () => void;
};

export const useFormStore = create<FormProps>((set) => ({
  currentStep: 0,
  entityType: '',
  isFormSubmittedSuccess: false,
  isFormSubmittedFailure: false,
  setIsFormSubmittedSuccess: (status: boolean) => set({ isFormSubmittedSuccess: status }),
  setIsFormSubmittedFailure: (status: boolean) => set({ isFormSubmittedFailure: status }),
  changeEntityType: (newEntityType: string) => set({ entityType: newEntityType }),
  nextStep: () => set((state) => ({ currentStep: state.currentStep + 1 })),
  prevStep: () => set((state) => ({ currentStep: state.currentStep - 1 }))
}));
